export const addBpayDetailsFormInitialValue = {
  billerCode: '',
  billerName: '',
  nicknameNew: '',
  crnNew: '',
}
